import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const ReportIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.3841 10.0391C19.6387 10.2512 19.6731 10.6295 19.461 10.8841L16.961 13.8841C16.7716 14.1113 16.4449 14.1667 16.1913 14.0145L14.132 12.7789L11.961 15.3841C11.7518 15.6351 11.3803 15.6726 11.1252 15.4685L9.08445 13.8359L6.96096 16.3841C6.84696 16.5209 6.67809 16.6 6.50002 16.6H5.00002C4.66865 16.6 4.40002 16.3314 4.40002 16C4.40002 15.6686 4.66865 15.4 5.00002 15.4H6.219L8.53909 12.6159C8.74824 12.3649 9.11974 12.3274 9.37484 12.5315L11.4156 14.1641L13.5391 11.6159C13.7284 11.3887 14.0551 11.3333 14.3087 11.4855L16.3681 12.7211L18.5391 10.1159C18.7512 9.86132 19.1296 9.82693 19.3841 10.0391Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.00002 8.00547V17C2.00002 18.6569 3.34317 20 5.00002 20H19C20.6569 20 22 18.6569 22 17V7C22 5.34315 20.6569 4 19 4H5.00002C3.34317 4 2.00002 5.34315 2.00002 7V7.99453L2 8L2.00002 8.00547ZM19 5.2H5.00002C4.00591 5.2 3.20002 6.00589 3.20002 7V7.4H20.8V7C20.8 6.00589 19.9941 5.2 19 5.2ZM20.8 8.6H3.20002V17C3.20002 17.9941 4.00591 18.8 5.00002 18.8H19C19.9941 18.8 20.8 17.9941 20.8 17V8.6Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

ReportIcon.propTypes = iconPropTypes;
ReportIcon.defaultProps = iconDefaultProps;
